import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchRoles = async () => {
  const uri = `v1/roles`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateRole = async (data: any) => {
  const uri = `v1/roles`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateRole = async ({ _id, data }: any) => {
  const uri = `v1/roles/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteRole = async ({ _id, data }: any) => {
  const uri = `v1/roles/${_id}`;
  const response = deleteData({ data, uri });
  return response;
};

const handleCreateLevel = async ({ _id, data }: any) => {
  const uri = `v1/roles/${_id}/levels`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateLevel = async ({ _id, levelId, data }: any) => {
  const uri = `v1/roles/${_id}/levels/${levelId}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteLevel = async ({ _id, levelId, data }: any) => {
  const uri = `v1/roles/${_id}/levels/${levelId}`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchRoles,
  handleCreateRole,
  handleUpdateRole,
  handleDeleteRole,
  handleCreateLevel,
  handleUpdateLevel,
  handleDeleteLevel,
};
